import { FreightItem } from '@/models/quote-template';
import { QuoteFreightItemService } from '@/services/quote-freight-service';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const quoteFreightService = new QuoteFreightItemService();

export const state = {
  freightItems: [] as FreightItem[]
};

type QuotesState = typeof state;

export const mutations: MutationTree<QuotesState> = {
  SET_QUOTE_FREIGHT_ITEMS(state, payload: FreightItem[]) {
    state.freightItems = payload;
  },

  ADD_QUOTE_FREIGHT_ITEM(state, payload: FreightItem) {
    state.freightItems.push(payload);
  },

  UPDATE_QUOTE_FREIGHT_ITEM(state, payload: FreightItem) {
    const index = state.freightItems.findIndex(
      (quoteFreight: FreightItem) => quoteFreight.id === payload.id
    );
    state.freightItems.splice(index, 1, payload);
  },

  REMOVE_QUOTE_FREIGHT_ITEM(state, payload: number) {
    const index = state.freightItems.findIndex(
      (quoteFreight: FreightItem) => quoteFreight.id === payload
    );
    state.freightItems.splice(index, 1);
  }
};

export const actions: ActionTree<QuotesState, QuotesState> = {
  createQuoteFreight: async ({ commit }, payload: FreightItem) =>
    quoteFreightService
      .createQuoteFreight(payload)
      .then((quoteFreight: FreightItem) =>
        commit('ADD_QUOTE_FREIGHT_ITEM', quoteFreight)
      ),

  fetchQuoteFreights: async ({ commit }, language?: string) =>
    quoteFreightService
      .fetchQuoteFreights(language)
      .then((freightItems: FreightItem[]) => {
        commit('SET_QUOTE_FREIGHT_ITEMS', freightItems);
      }),

  fetchQuoteFreight: async ({ commit }, payload: number) =>
    quoteFreightService
      .fetchQuoteFreight(payload)
      .then((quoteFreight: FreightItem) => {
        const index = state.freightItems.findIndex(
          (v: FreightItem) => v.id === quoteFreight.id
        );
        if (index === -1) {
          commit('ADD_QUOTE_FREIGHT_ITEM', quoteFreight);
        } else {
          commit('UPDATE_QUOTE_FREIGHT_ITEM', quoteFreight);
        }
        return quoteFreight;
      }),

  updateQuoteFreight: async ({ state, commit }, payload: FreightItem) =>
    quoteFreightService
      .updateQuoteFreight(payload)
      .then((quoteFreight: FreightItem) => {
        const index = state.freightItems.findIndex(
          (v: FreightItem) => v.id === quoteFreight.id
        );
        if (index === -1) {
          commit('ADD_QUOTE_FREIGHT_ITEM', quoteFreight);
        } else {
          commit('UPDATE_QUOTE_FREIGHT_ITEM', quoteFreight);
        }
      }),

  deleteQuoteFreight: async ({ commit }, payload: number) =>
    quoteFreightService.deleteQuoteFreight(payload).then(() => {
      commit('REMOVE_QUOTE_FREIGHT_ITEM', payload);
    })
};

export const getters: GetterTree<QuotesState, QuotesState> = {
  getQuoteFreightById: state => (id: number) =>
    state.freightItems.find(quoteFreight => quoteFreight.id === id)
};
